import { debugEnabled } from './authTrace';

// Dispatch Brief v2, Phase 2 (2026-08-05) — eruda on-screen console.
//
// The brief's spec called for a CDN <script src="https://cdn.jsdelivr.net/npm/eruda">
// injected via an inline <script> in public/index.html, gated on the same
// debug flag. firebase.json's CSP (script-src 'self' <specific sha256 hash>
// <3 named origins>, no 'unsafe-inline') blocks BOTH halves of that: a new
// inline <script> block has no matching hash, and cdn.jsdelivr.net isn't in
// script-src. Loosening the CSP to fit is out of scope for a recon-only pass
// (a security header affecting every user, not a debug-only concern), so
// per the brief's own fallback instruction this is vendored into the bundle
// instead: eruda is a devDependency, dynamically imported only behind this
// gate, and initialised here — every byte of it ships from 'self', already
// covered by the existing CSP.
export async function initDebugConsole() {
  if (!debugEnabled) return;
  const eruda = await import('eruda');
  eruda.default.init();
}
